import { useTranslation } from 'react-i18next';
import { PAGE_PATH } from '../seo';

// Selector de idioma ES / EN. Cada idioma es su propia URL (/ y /en/), así que
// son enlaces normales: el idioma lo decide la ruta, no un cambio por JS.
export function LangSwitcher({ className = '' }: { className?: string }) {
  const { t, i18n } = useTranslation();
  const current = i18n.resolvedLanguage?.startsWith('en') ? 'en' : 'es';

  return (
    <div
      className={`inline-flex items-center rounded-full border border-clay-300/20 p-0.5 text-xs font-semibold ${className}`}
      role="group"
      aria-label={t('lang.label')}
    >
      {(['es', 'en'] as const).map((lng) => (
        <a
          key={lng}
          href={PAGE_PATH[lng]}
          hrefLang={lng}
          aria-current={current === lng ? 'page' : undefined}
          className={`rounded-full px-2.5 py-1 transition ${
            current === lng
              ? 'bg-amber-glow text-clay-950'
              : 'text-clay-300 hover:text-amber-glow'
          }`}
        >
          {t(`lang.${lng}`)}
        </a>
      ))}
    </div>
  );
}
